import React, { useState, useEffect } from "react";
import { Button, Col, Row, Table, Form, Spinner } from "react-bootstrap";
import { Link } from "react-router-dom";
import { formatDate, formatDateForView, getUserDetails } from "../../utils/helper";
import {
  DatatableWrapper,
  Pagination,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import moment from "moment";
import Confirm from "../Confirm";
import FilesEdit from "./FilesEdit";
import FilesView from "./FilesView";
import fileDownload from "js-file-download";
import * as constants from "../../constants/CONSTANT";
import { render } from "@testing-library/react";
import Permissionhelper from "../common/Permissionhelper";
import solisPowerApi from "../../api/solisPowerApi";
import PERMISSIONS from "../../constants/permissions";

const RelatedListFiles = (props) => {
  const userInfo = getUserDetails();
  const [modalShow, setModalShow] = React.useState(false);
  const [showRecord, setShowRecords] = React.useState(false);
  const [file, setFile] = React.useState("");
  const [downloads, setDownloads] = React.useState([]);
  const [modalShowFile, setModalShowFile] = React.useState(false);
  const [modalShowFileView, setModalShowFileView] = React.useState(false);
  const [folderName, setfolderName] = React.useState(""); //Added by shivani

  const [body, setBody] = useState([]);
  const MIMEType = new Map([
    ["text/csv", "csv"],
    ["application/msword", "doc"],
    [
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "docx",
    ],
    ["image/gif", "gif"],
    ["text/html", "html"],
    ["image/jpeg", "jpeg"],
    ["image/jpg", "jpg"],
    ["application/json", "json"],
    ["audio/mpeg", "mp3"],
    ["video/mp4", "mp4"],
    ["image/png", "png"],
    ["application/pdf", "pdf"],
    ["application/vnd.ms-powerpoint", "ppt"],
    [
      "application/vnd.openxmlformats-officedocument.presentationml.presentation",
      "pptx",
    ],
    ["image/svg+xml", "svg"],
    ["text/plain", "txt"],
    ["application/vnd.ms-excel", "xls"],
    [
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "xlsx",
    ],
    ["text/xm", "xml"],
    ["application/xml", "xml"],
    ["application/atom+xml", "xml"],
    ["application/zip", "zip"],
  ]);

  useEffect(() => {
    filesList(folderName); //Added by shivani
  }, [props.refreshFileList]);

  const handleDelete = (row) => {
    setModalShow(true);
    setFile(row);
  };
  console.log("onFileUpdate", props.onFileUpdate);

  const labels = {
    beforeSelect: " ",
  };

  const deleteFile = async () => {
    ////console.log('delete call', file.id)
    const result = await solisPowerApi.deleteFile(file.id);
    //console.log('delete successfully ',result)
    if (result.success) {
      const filterFiles = body.filter((item) => item.id !== file.id);
      setBody(filterFiles);
      setModalShow(false);
      props.submitFiles();
    }
  };

  const downloadFile = async (row) => {
    //console.log('if file download call',row);
    const result = await solisPowerApi.downloadFiles(row.id, folderName); //FolderName to download
    if (result) {
      fileDownload(result, row.title);
    }
  };

  const submitFiles = () => {
    setModalShowFile(false);
    setShowRecords(Date.now());
    filesList(folderName);
    console.log("props", props);
    props.submitFiles();
  };

  const editFile = (row) => {
    setModalShowFile(true);
    setFile(row);
  };

  const fileView = (row) => {
    setModalShowFileView(true);
    setFile(row);
  };

  const filesList = (foldername) => {
    async function init() {
      //console.log('variable:', props.parent);
      if (props.parent.id && foldername) {
        let files = await solisPowerApi.fetchFiles(
          props.parent.id,
          foldername
        );
        console.log("FILES", files);
        if (files && files?.length > 0) {
          let arr = [];

          for (let i = 0; i < files.length; i++) {
            let file = files[i];
            if (
              file.filetype === "jpg" ||
              file.filetype === "jpeg" ||
              file.filetype === "png"
            ) {
              //////console.log('fetch:', file.filetype);
              let result = await solisPowerApi.downloadFiles(
                file.id,
                foldername
              );
              //////console.log('result:', result);
              file["body"] = window.URL.createObjectURL(result);
            } else {
              file["body"] = "";
            }

            arr.push(file);
          }

          setBody([...arr]);
        } else {
          setBody([]);
        }
      }
    }
    init();
  };

  const handleFolderChange = (e) => {
    let foldername = e.target.value;
    setfolderName(foldername); //Added by shivani
    console.log("foldername", foldername);
    // if(props.table === "Product"){
    //   foldername = props.table;
    // }
    console.log("Final Folder", foldername);
    if (foldername) {
      console.log("foldername2", foldername);
      filesList(foldername);
    }
  };

  const fileSize = (bytes) => {
    var exp = bytes / 1024 / 1024;
    return exp.toFixed(2) + " MB";
  };

  const renderPreview = (type, body) => {
    //////console.log(type);
    switch (type) {
      case constants.PDF:
        return <i className="fa-solid fa-file-pdf fa-2xl file-thumbnail"></i>;
      case constants.DOC:
      case constants.DOCX:
        return <i className="fa-solid fa-file-word fa-2xl file-thumbnail"></i>;
      case constants.XLS:
      case constants.XLSX:
        return <i className="fa-solid fa-file-excel fa-2xl file-thumbnail"></i>;
      case constants.PNG:
      case constants.JPG:
      case constants.JPEG:
        return (
          <a href={body} target="_blank" rel="noopener noreferrer">
            <img className="file-thumbnail" src={body} alt="" />
          </a>
        );
      default:
        return <i className="fa-solid fa-file-file fa-2xl file-thumbnail"></i>;
    }
  };

  // Added by shivani start
  const header = [
    {
      title: "Title",
      prop: "title",
      cell: (row) => (
        <div className="text-truncate" style={{ maxWidth: "250px" }}>
          <a
            href="javascript:void(0)"
            onClick={() => fileView({ row })}
            className="d-block"
          >
            {row.title}
          </a>
        </div>
      ),
    },
    {
      title: "",
      prop: "body",
      cell: (row) => {
        const isImage = row.filetype === "jpg" || row.filetype === "jpeg" || row.filetype === "png";
        return (
          <div className="text-center related-list-file-preview" style={{ height: "50px", width: "50px" }}>
            {isImage ? (
              renderPreview(row.filetype, row.body)
            ) : (
              <a href="javascript:void(0)" onClick={() => downloadFile(row)}>
                {renderPreview(row.filetype, row.body)}
              </a>
            )}
          </div>
        );
      },
    },
    { title: "File Type", prop: "filetype", cell: (row) => row.filetype },
    {
      title: "File Size",
      prop: "filesize",
      cell: (row) => fileSize(row.filesize),
    },
    { title: "Folder Name", prop: "file_path" },
    { title: "Description", prop: "description" },
    // { title: "Lead/Project", prop: "name" },
    // {
    //   title: "Primary Image",
    //   prop: "primary_image",
    //   cell: (row) => <div>{row.primary_image ? "Active" : "Inactive"}</div>,
    // },
    // { title: "Quote Status", prop: "quote_status" },
    //formatDateForView added by shahir hussain 27-08-2025
    {
      title: "Created Date",
      prop: "createddate",
      cell: (row) => (
        row?.createddate ? formatDateForView(row.createddate) : ''
      ),
    },
    {
      title: "Actions",
      prop: "id",
      cell: (row) => (
        <div className="d-flex justify-content-center align-items-center">
          {[PERMISSIONS.MODIFY_ALL, PERMISSIONS?.MODIFY_FILE].some(permission => {
            return userInfo?.permissions.map(p => p.name).includes(permission);
          }) &&
            <Button className="btn-sm mx-1" onClick={() => editFile({ row })}>
              <i className="fa-regular fa-pen-to-square"></i>
            </Button>
          }
          {[PERMISSIONS.DELETE_ALL, PERMISSIONS?.DELETE_FILE].some(permission => {
            return userInfo?.permissions.map(p => p.name).includes(permission);
          }) && (
              <Button
                className="btn-sm mx-1"
                variant="danger"
                onClick={() => handleDelete(row)}
              >
                <i className="fa-regular fa-trash-can"></i>
              </Button>
            )}

          <Button
            className="btn-sm mx-1"
            variant="danger"
            onClick={() => downloadFile(row)}
          >
            <i className="fa-solid fa-download"></i>
          </Button>
        </div>
      ),
    },
  ];
  // Added by shivani end

  const folderList = [
    { label: "Building photo", value: "BuildingPhoto" },
    { label: "Roof photos", value: "RoofPhotos" },
    { label: "Product location", value: "ProductLocation" },
    { label: "Layout photo", value: "LayoutPhoto" }
  ];


  return (
    <>
      {modalShow && (
        <Confirm
          show={modalShow}
          onHide={() => setModalShow(false)}
          deleteFile={deleteFile}
          title="Confirm delete?"
          message="You are going to delete the record. Are you sure?"
          table="file"
        />
      )}
      {modalShowFile && (
        <FilesEdit
          show={modalShowFile}
          onFileUpdate={props.onFileUpdate}
          onHide={() => setModalShowFile(false)}
          parent={props.parent}
          file={file}
          table={props.table}
          submitFiles={submitFiles}
        />
      )}
      {modalShowFileView && (
        <FilesView
          show={modalShowFileView}
          onHide={() => setModalShowFileView(false)}
          file={file}
        />
      )}
      {body ? (
        <DatatableWrapper
          body={body}
          headers={header}
          paginationOptionsProps={{
            initialState: {
              rowsPerPage: 5,
            },
          }}
        >
          <Row className="mb-4">
            <Col
              xs={12}
              sm={6}
              lg={4}
              className="d-flex flex-col justify-content-start align-items-start"
            ></Col>

            <Col
              xs={12}
              sm={6}
              lg={4}
              className="d-flex flex-col justify-content-start align-items-start"
            ></Col>
            <Col
              xs={12}
              sm={6}
              lg={4}
              className="d-flex flex-col justify-content-end align-items-end"
            ></Col>
            {/* {props.table !== "Product" && ( */}
            <Col md={4}>
              <>
                <h6>Folder</h6>

                <div className="d-flex flex-wrap gap-2 mb-2">
                  {folderList.map((item, index) => {
                    const variants = ["primary", "secondary", "success", "warning"];

                    return (
                      <Button
                        key={index}
                        variant={variants[index % variants.length]}
                        size="sm"
                        onClick={() =>
                          handleFolderChange({
                            target: { name: "folder_name", value: item.value }
                          })
                        }
                      >
                        {item.label}
                      </Button>
                    );
                  })}
                </div>
              </>
              {/* 
              <Form.Group>
                <Form.Label className="" htmlFor="formFolderName">
                  Folder Name
                </Form.Label>
                <Form.Select
                  aria-label="Select Folder"
                  value={folderName}
                  name="folder_name"
                  onChange={handleFolderChange}
                >
                <option value="">--Select Folder--</option>
                <option value="SiteMeasurement">Site Measurement</option>
                <option value="LeadDocument">Lead Documents</option>
                <option value="ProductImages">Products Images</option>
                <option value="ContactImages">Contact Images</option>
                </Form.Select>
              </Form.Group> */}
            </Col>
            {/* )} */}
          </Row>
          <Table
            striped
            className="related-list-table shadow rounded sm "
            responsive={true}
          >
            <TableHeader classes={{ th: "bg-custom text-white" }} />
            {body && Array.isArray(body) ? (
              <TableBody />
            ) : (
              <tbody className="">
                <tr>
                  <td colSpan={100} align="center">
                    <div>
                      <Spinner />
                    </div>
                  </td>
                </tr>
              </tbody>
            )}
          </Table>
          <Pagination
            classes={{
              buttonGroup: "btn-custom",
              button: "bg-custom border-white",
            }}
          />
        </DatatableWrapper>
      ) : (
        ""
      )}
      <p style={{ color: "red" }}>
        {downloads?.length > 0
          ? downloads.map((row, index) => <img src={row} alt="" />)
          : ""}
      </p>
    </>
  );
};

export default RelatedListFiles;
